import React from 'react';
import ActionField from './fields/ActionField';

const DataActionStep = () => <ActionField />;

export default DataActionStep;
